// V4.12 Phase C — AI ↔ Heatmap shared search context.
// GET returns the user's last canonical search (written by the AI
// `search_listings` tool or by the heatmap chip bar). PUT persists the
// heatmap's active filters so the AI knows them too.
import { apiClient } from "./client";

export async function fetchSearchContext() {
  const r = await apiClient.get("/search-context");
  return r.data;
}

export async function putSearchContext({ vertical, filters, label }) {
  const r = await apiClient.put("/search-context", { vertical, filters, label });
  return r.data;
}
